import { format } from "date-fns";

const formatStartDate = (dateStr) => {
	const year = dateStr.getFullYear();
	const monthIndex = dateStr.getMonth();
	const day = dateStr.getDate();

	return new Date(year, monthIndex, day);
};

const formatEndDate = (dateStr) => {
	const year = dateStr.getFullYear();
	const monthIndex = dateStr.getMonth();
	const day = dateStr.getDate();

	return new Date(year, monthIndex, day + 1);
};

const newDateFormatter = (str, formatType = "do MMM yyyy") => {
	if (str) {
		return format(new Date(str), formatType);
	}
	return "";
};

const downloadImage = (src) => {
	const img = new Image();
	img.crossOrigin = "anonymous";
	img.src = src;
	img.onload = () => {
		// create Canvas
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");
		canvas.width = img.width;
		canvas.height = img.height;
		ctx.drawImage(img, 0, 0);
		// create <a> tag
		const a = document.createElement("a");
		a.download = "request-file.png";
		a.href = canvas.toDataURL("image/png");
		a.click();
	};
};

// const downloadPdf = (src) => {
// 	// const img = new Image();
// 	// img.crossOrigin = "anonymous";
// 	// img.src = src;
// 	// img.onload = () => {
// 	// 	// create Canvas
// 	// 	const canvas = document.createElement("canvas");
// 	// 	const ctx = canvas.getContext("2d");
// 	// 	canvas.width = img.width;
// 	// 	canvas.height = img.height;
// 	// 	ctx.drawImage(img, 0, 0);
// 	// 	// create <a> tag
// 	// 	const a = document.createElement("a");
// 	// 	a.download = "request-file.png";
// 	// 	a.href = canvas.toDataURL("image/png");
// 	// 	a.click();
// 	// };
// 	const a = document.createElement("a");
// 	a.download = "request-file.png";
// 	a.href = src;
// 	a.click();
// };

const isUriImage = (uri) => {
	// make sure we remove any nasty GET params
	const newUri = uri.split("?")[0];
	// moving on, split the uri into parts that had dots before them
	const parts = newUri.split(".");
	// get the last part ( should be the extension )
	const extension = parts[parts.length - 1];
	// define some image types to test against
	const imageTypes = ["jpg", "jpeg", "tiff", "png", "gif", "bmp"];
	// check if the extension matches anything in the list.
	if (imageTypes.indexOf(extension) !== -1) {
		return true;
	}
	return false;
};

const isUriPdf = (uri) => {
	// make sure we remove any nasty GET params
	const newUri = uri.split("?")[0];
	// moving on, split the uri into parts that had dots before them
	const parts = newUri.split(".");
	// get the last part ( should be the extension )
	const extension = parts[parts.length - 1];
	// define some image types to test against
	const imageTypes = ["pdf"];
	// check if the extension matches anything in the list.
	if (imageTypes.indexOf(extension) !== -1) {
		return true;
	}
	return false;
};

const downloadDocument = (src) => {
	const isFileimage = isUriImage(src);
	const ifFilePdf = isUriPdf(src);
	if (isFileimage) {
		downloadImage(src);
	}
	if (ifFilePdf) {
		window.open(src, "_blank");
	}
};

const getBase64ImageFromUrl = async (imageUrl) => {
	const res = await fetch(imageUrl);
	const blob = await res.blob();
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.addEventListener(
			"load",
			function () {
				resolve(reader.result);
			},
			false
		);
		reader.onerror = () => {
			// eslint-disable-next-line prefer-promise-reject-errors
			return reject(this);
		};
		reader.readAsDataURL(blob);
	});
};

export {
	formatStartDate,
	formatEndDate,
	newDateFormatter,
	downloadImage,
	getBase64ImageFromUrl,
	downloadDocument,
};
